import store from '../store/store';

/**
 * Hook free version of CLocalizedTextString.
 * Safely returns localized text as plain string or raw HTML.
 * Can be used in services, utilities, or classes.
 */
export default function CLocalizedTextStringStatic(dictKey: string, returnRawString?: boolean) {
  const { localeDict } = store.getState().dashboard;
  const html = localeDict?.[dictKey] ?? `[${dictKey}]`;
  if (returnRawString) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerHTML;
  } else return html;
}
